import {
  DeleteOutline,
  DescriptionOutlined,
  Download,
} from "@mui/icons-material";
import Libelle from "../../../../../../_i18n/fr.json";
import FailureIcon from "@mui/icons-material/Cancel";
import ValidIcon from "@mui/icons-material/CheckCircle";
import WaitingIcon from "@mui/icons-material/Timelapse";
import {
  Alert,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  Grid,
  LinearProgress,
  Link,
  Modal,
  Typography,
} from "@mui/material";
import Grid2 from "@mui/material/Unstable_Grid2";
import messages from "../../../../../../_i18n/fr.json";
import Bouton from "../../../../../../components/Button/Bouton";
import Error from "../../../../../../components/Error";
import InputFileDragDrop from "../../../../../../components/InputFileDragDrop";
import { formatDateCourt } from "../../../../../../helpers/formatters";
import { isDateDebutSituationPlus1an } from "../../../../../../helpers/validators";
import ModifyIcon from "../../../../../../ressources/images/ModifyIcon.svg";
import PiecesIcon from "../../../../../../ressources/images/PiecesIcon.svg";
import SituationPersoIcon from "../../../../../../ressources/images/SituationPersoIcon.svg";
import SituationProIcon from "../../../../../../ressources/images/SituationProIcon.svg";
import { DossierParticulierDetail } from "../../../../../../services/Api/swagger";
import { useInfoCandidat } from "./selectors";
import Snack from "../../../../../../components/Snack";

interface Props {
  personne?: DossierParticulierDetail;
  cantModify: boolean;
  isConjoint?: boolean;
  allEtudiant?: boolean;
  hasGarant?: boolean;
  canAddGarant?: boolean;
  isCandidatLocataire?: boolean;
  statutDossier?: string;
  refDossier?: string;
}

function InfoCandidat({
  personne,
  cantModify,
  isConjoint,
  allEtudiant,
  hasGarant,
  canAddGarant,
  isCandidatLocataire,
  statutDossier,
  refDossier,
}: Props) {
  const {
    archiveFetching,
    archiveError,
    isControleDossier,
    isCumulsUtilises,
    errorDocument,
    isFetchingDocument,
    handlePostDocument,
    newDocument,
    setAddDocument,
    getDocument,
    isFetchingGetDocument,
    errorGetDocument,
    listSituationPro,
    modifyNetheos,
    postGarant,
    handleDownloadArchive,
    setIdDocumentDelete,
    handleDeleteDocument,
    isFetchingDeleteDocument,
    errorDeleteDocument,
    idDocumentDelete,
    handleCancelDeleteDocument,
    isSuccessDeleteDocument,
    resetDeleteDocument,
  } = useInfoCandidat(personne, refDossier);
  if (personne) {
    const situationPro =
      listSituationPro &&
      personne.codeStatutProfessionnel &&
      listSituationPro.find(
        (situation) =>
          situation.statutsProfessionnels &&
          situation.statutsProfessionnels.find(
            (statut) => statut.code === personne.codeStatutProfessionnel
          )
      );
    const statutPro =
      situationPro &&
      situationPro.statutsProfessionnels &&
      personne.codeStatutProfessionnel &&
      situationPro.statutsProfessionnels.find(
        (statut) => statut.code === personne.codeStatutProfessionnel
      );
    const dossierNetheos = personne.dossierPieces;
    const isDateDebutActivitePlus1an = isDateDebutSituationPlus1an(
      personne.dateDebutSituationProfessionnelle
    );
    return (
      <Grid container justifyContent="flex-start" className={"candidat"}>
        <div>
          <h4>
            <img src={SituationPersoIcon} width="27" height="27" alt="" />{" "}
            Identité et coordonnées {/* true + false  */}
            {cantModify || personne.statut === "VALIDE" ? null : (
              <Link href="/dossier-location/situation-personnelle">
                <img
                  alt="modifier situation personnelle"
                  src={ModifyIcon}
                  width={24}
                  height={24}
                  className={"modifyIcon"}
                />
              </Link>
            )}
          </h4>
          <p className="capitalize">
            {personne.qualite + " "}
            <strong>{personne.prenom + " " + personne.nom}</strong>
          </p>
          <p>
            Né(e) le :{" "}
            {personne.dateNaissance && (
              <strong>{formatDateCourt(personne.dateNaissance)}</strong>
            )}
          </p>

          {!isConjoint && (
            <p>Mail :{personne.email && <strong>{personne.email}</strong>}</p>
          )}

          {!isConjoint && (
            <p>
              N° portable :{" "}
              {personne.telephonePortable && (
                <strong>{personne.telephonePortable}</strong>
              )}
            </p>
          )}
          {!isConjoint && (
            <p>
              Adresse actuelle :{" "}
              <strong>
                {personne.numeroBatiment && (
                  <span> bât. {personne.numeroBatiment}, </span>
                )}
                {personne.numero}{" "}
                {personne.typeVoie && personne.typeVoie.toLowerCase()}{" "}
                {personne.adresse && personne.adresse}
                {", "}
                {personne.codePostal && personne.codePostal}{" "}
                {personne.ville && personne.ville}{" "}
                {personne.dateEntree &&
                  " depuis le " + formatDateCourt(personne.dateEntree)}
                {personne.statutOccupation &&
                  " en qualité de " +
                    messages.statutOccupation[personne.statutOccupation]}
              </strong>
            </p>
          )}
          {!isConjoint && (
            <p>
              Situation :{" "}
              <strong>
                {personne.situationMaritale &&
                  messages.situationMaritale[personne.situationMaritale]}
                {personne.enfants && personne.enfants.length > 0 && (
                  <span>, {personne.enfants.length + " enfant(s)"}</span>
                )}
              </strong>
            </p>
          )}
          <div className={"blocCandidat"}>
            <h4>
              <img src={SituationProIcon} width="27" height="27" alt="" />
              Situation professionnelle{" "}
              {cantModify || personne.statut === "VALIDE" ? null : (
                <Link href="/dossier-location/situation-professionnelle">
                  <img
                    alt="modifier situation profesionnelle"
                    src={ModifyIcon}
                    width={24}
                    height={24}
                    className={"modifyIcon"}
                  />
                </Link>
              )}
            </h4>

            <p>
              {situationPro &&
                situationPro.code !== "ETU" &&
                situationPro.code !== "RET" &&
                situationPro.code !== "RCH" &&
                situationPro.code !== "SAC" &&
                situationPro.libelle}{" "}
              <strong>{statutPro && statutPro.libelle} </strong>
              {personne.dateDebutSituationProfessionnelle && (
                <span>
                  depuis le
                  <strong>
                    {formatDateCourt(
                      personne.dateDebutSituationProfessionnelle
                    )}
                  </strong>
                </span>
              )}{" "}
              {personne.dateFinSituationProfessionnelle && (
                <span>
                  jusqu'à
                  <strong>
                    {formatDateCourt(personne.dateFinSituationProfessionnelle)}
                  </strong>
                </span>
              )}
            </p>
            {(personne.salaireNetImposableM1 ||
              personne.salaireNetImposableM1 === 0) && (
              <>
                <h5>Revenus </h5>
                <p>
                  Salaires mensuels :
                  <strong>
                    {personne.salaireNetImposableM1 + "€"}
                    {(personne.salaireNetImposableM2 ||
                      personne.salaireNetImposableM2 === 0) &&
                      ", " + personne.salaireNetImposableM2 + "€"}
                    {(personne.salaireNetImposableM3 ||
                      personne.salaireNetImposableM3 === 0) &&
                      ", " + personne.salaireNetImposableM3 + "€ "}
                  </strong>
                </p>
                {isCumulsUtilises && isDateDebutActivitePlus1an && (
                  <p>
                    Cumul annuel salaires :
                    <strong>
                      {personne.cumulSalaireNetImposableM1 + "€"}
                      {(personne.cumulSalaireNetImposableM2 ||
                        personne.cumulSalaireNetImposableM2 === 0) &&
                        ", " + personne.cumulSalaireNetImposableM2 + "€"}
                      {(personne.cumulSalaireNetImposableM3 ||
                        personne.cumulSalaireNetImposableM3 === 0) &&
                        ", " + personne.cumulSalaireNetImposableM3 + "€ "}
                    </strong>
                  </p>
                )}
              </>
            )}
            {(personne.salaireBrutMensuel ||
              personne.salaireBrutMensuel === 0) && (
              <>
                <h5>Revenus </h5>
                <p>
                  Salaire brut mensuel
                  <strong>{personne.salaireBrutMensuel} €</strong>
                </p>
                <p>
                  Salaire net mensuel
                  <strong>{personne.salaireNetMensuel} €</strong>
                </p>
              </>
            )}
            {(personne.revenuIndividuelDeclare ||
              personne.revenuIndividuelDeclare === 0) && (
              <p>
                Revenu individuel déclaré :
                <strong>{personne.revenuIndividuelDeclare}€ </strong>
              </p>
            )}
            {personne.revenuFiscalReference && (
              <p>
                Revenu fiscal de référence imposable :
                <strong>{personne.revenuFiscalReference}€ </strong>
              </p>
            )}
            <div className={"blocCandidat"}>
              <h4>
                <img src={PiecesIcon} width="27" height="27" alt="" />
                Les pièces du dossier{" "}
                {cantModify ||
                !isControleDossier ||
                personne.statut === "VALIDE" ||
                (dossierNetheos &&
                  dossierNetheos.statut === "ACCEPTED") ? null : (
                  <Button onClick={modifyNetheos} className={"buttonPieces"}>
                    <img
                      alt="modifier les pièces du dossier"
                      src={ModifyIcon}
                      width={24}
                      height={24}
                      className={"modifyIcon"}
                    />
                  </Button>
                )}
              </h4>
              {dossierNetheos && dossierNetheos.reference && (
                <p>
                  Numéro personne : <strong>{dossierNetheos.reference}</strong>
                </p>
              )}
              {((dossierNetheos &&
                dossierNetheos.piecesJustificatives &&
                dossierNetheos.piecesJustificatives.length > 0) ||
                ((!isControleDossier || isCandidatLocataire) &&
                  personne.statut === "VALIDE")) && (
                <Grid container className={"downloadArchive"}>
                  <p>Téléchargez votre archive :</p>
                  <Link
                    component="button"
                    // tslint:disable-next-line: jsx-no-lambda
                    onClick={() => handleDownloadArchive()}
                    underline="always"
                    variant="body2"
                  >
                    documents.zip
                  </Link>
                  {archiveFetching && <CircularProgress size={20} />}
                  {archiveError && (
                    <Typography color="error" variant="body2">
                      {"Erreur de téléchargement, veuillez réessayer"}
                    </Typography>
                  )}
                </Grid>
              )}
              {!isControleDossier && personne.statut !== "VALIDE" && (
                <p>
                  Les pièces justificatives n'ont pas encore été envoyées par le
                  partenaire
                </p>
              )}
              {dossierNetheos &&
              dossierNetheos.piecesJustificatives &&
              dossierNetheos.piecesJustificatives.length > 0
                ? dossierNetheos.piecesJustificatives.map((piece, i) => {
                    let icon = <ValidIcon className={"icon  iconValid"} />;
                    if (
                      piece.pieceJustificativeErreurs &&
                      piece.pieceJustificativeErreurs.length > 0
                    ) {
                      icon = <FailureIcon className={"icon iconFailed"} />;
                    } else if (piece.statut === "NOT_VALIDATED") {
                      icon = <WaitingIcon className={"icon iconWait"} />;
                    }

                    const errors = piece.pieceJustificativeErreurs
                      ? piece.pieceJustificativeErreurs.map((error) => (
                          <Error
                            className={"errorPiece"}
                            key={error.code}
                            text={error.libelle || ""}
                          />
                        ))
                      : "";

                    return (
                      <>
                        <p className={"pieces"} key={i}>
                          {icon}
                          <strong> {piece.libelle}</strong>
                        </p>
                        {errors}
                      </>
                    );
                  })
                : isControleDossier &&
                  !isCandidatLocataire && (
                    <p>
                      Vous n'avez pas encore ajouté de pièces justificatives
                    </p>
                  )}

              {statutDossier !== "INCOMPLET" && (
                <div className="autres-pieces">
                  <div>
                    <Typography variant="h5">Autres pièces : </Typography>
                    {personne.autresPieces &&
                      personne.autresPieces.map((piece) => {
                        return (
                          <Grid2 container>
                            <p className={"pieces"} key={piece.id}>
                              {<DescriptionOutlined fontSize="small" />}
                              <strong> {piece.nom}</strong>
                            </p>
                            <Bouton
                              icon={<Download />}
                              label="Télécharger"
                              onClick={() => getDocument(piece.id)}
                              size="small"
                              variant="text"
                              color="inherit"
                            />
                            <Bouton
                              icon={<DeleteOutline />}
                              onClick={() => setIdDocumentDelete(piece.id)}
                              label="Supprimer"
                              size="small"
                              variant="text"
                              color="inherit"
                            />
                          </Grid2>
                        );
                      })}
                    {isFetchingGetDocument && <LinearProgress />}
                    {errorGetDocument && (
                      <Alert severity="error" sx={{ mt: 1, fontSize: 13 }}>
                        {errorGetDocument.response?.data?.message ||
                          "Une erreur est survenue"}
                      </Alert>
                    )}
                  </div>
                  {!personne.autresPieces ||
                  personne.autresPieces === null ||
                  (personne.autresPieces &&
                    personne.autresPieces.length < 5) ? (
                    <>
                      <p>
                        <strong>Ajouter des pièces justificatives</strong>
                      </p>
                      <Grid className="add-pieces">
                        <InputFileDragDrop
                          onChange={setAddDocument}
                          value={newDocument}
                          name={"pieces" + personne.refDossierLocataire}
                          label="Ajouter ou glisser un fichier"
                          isFetching={isFetchingDocument}
                          errors={errorDocument}
                        />
                        <Grid2
                          container
                          alignItems="flex-end"
                          justifyContent="flex-end"
                          sx={{ mt: 2 }}
                        >
                          <Bouton
                            label="Enregistrer"
                            onClick={handlePostDocument}
                            variant="contained"
                            size="small"
                            color="secondary"
                          />
                        </Grid2>
                      </Grid>
                    </>
                  ) : (
                    <p>Nombre de pièces maximum atteintes (5 pièces max)</p>
                  )}
                </div>
              )}
            </div>
            {/* Si étudiant */}
            {personne &&
              personne.codeStatutProfessionnel === "ETU" &&
              allEtudiant &&
              canAddGarant &&
              !hasGarant && (
                <Bouton
                  onClick={postGarant}
                  className="bouton-garant"
                  label="+ Ajouter un(e) garant(e)"
                  color="primary"
                  variant="contained"
                  size="small"
                />
              )}
          </div>
        </div>
        {idDocumentDelete && (
          <Dialog
            open={Boolean(idDocumentDelete)}
            keepMounted
            onClose={undefined}
            sx={{
              "& .MuiDialog-paper": {
                p: 3,
              },
            }}
          >
            <DialogContent>
              Êtes vous sur(e) de vouloir supprimer ce document ?
            </DialogContent>
            <DialogActions>
              <Bouton
                onClick={handleCancelDeleteDocument}
                label="Annuler"
                color="secondary"
                variant="contained"
                size="small"
              />
              <Bouton
                onClick={handleDeleteDocument}
                label="Confirmer"
                color="primary"
                variant="contained"
                size="small"
              />
            </DialogActions>
            {isFetchingDeleteDocument && <LinearProgress />}

            {errorDeleteDocument && (
              <Alert color="error">
                {errorDeleteDocument.response?.data?.message ||
                  Libelle.erreurs.generique}
              </Alert>
            )}
          </Dialog>
        )}
        <Snack
          onClose={resetDeleteDocument}
          variant="success"
          message="Le document a bien été supprimé"
          open={isSuccessDeleteDocument}
        />
      </Grid>
    );
  } else {
    return null;
  }
}

export default InfoCandidat;
